import {useMemo} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {
  useQueryResponseData,
  useQueryResponseLoading,
  useQueryTotalPage,
} from '../core/QueryResponseProvider'
import {ReportSalesColumns} from './columns/_columns'
import {SaleReports} from '../core/_models'
import {ListPagination} from '../components/pagination/ListPagination'
import {KTCardBody} from '../../../../../_metronic/helpers'
import {LoadingListLoading} from '../../../../../utils/loading/loadingListLoading'
import {formatMask} from '../../../../../utils/formatMonetaryToBr'

const Table = () => {
  const user = useQueryResponseData()
  const totalPage = useQueryTotalPage()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => user, [user])
  const columns = useMemo(() => ReportSalesColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive mb-10'>
        <table
          id='kt_table_reportSales'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<SaleReports>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<SaleReports>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={columns.length}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    Nenhum registro encontrado
                  </div>
                </td>
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              <td>
                <strong>Total</strong>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>{totalPage?.sessions}</td>
              <td></td>
              <td>{formatMask(totalPage?.price)}</td>
              <td>{formatMask(totalPage?.discount)}</td>
              <td>{formatMask(totalPage?.voucherCredit)}</td>
              <td>{formatMask(totalPage?.totalPrice)}</td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
      <ListPagination />
      {isLoading && <LoadingListLoading title='Carregando' />}
    </KTCardBody>
  )
}

export {Table}
